module.exports = __webpack_public_path__ + "static/images/sun.562744c64a0d68bb4e8f0f161bf74bb2.svg";